
const ConnectSeller = ({glid, mobileNo}) => {

    const iframeURL = () => {
       return ""
    }
    
    return (
        <>
            <div>
                <iframe
                    src={iframeURL()}
                    title="Connect Seller UI"
                    style={{width:'100%', height:'800px', border:'none', marginTop:'450px'}}
                />
            </div>
        </>
    )
}

export default ConnectSeller;